import React from 'react';

import type { CMSData } from '../../FooterWidget';

import styles from './SocialMediaIcons.scss';

interface Props {
  socialIcons: CMSData['socialIcons'];
}

const SocialMediaIcons: React.FC<Props> = ({ socialIcons }) => (
  <div className={styles.socialMediaIcons}>
    {socialIcons.map(({ imageSource, imageLink }, index) => (
      <a target="_blank" rel="noopener noreferrer" href={imageLink} key={index}>
        <img src={imageSource.src} alt={imageSource.alt} />
      </a>
    ))}
  </div>
);

export default SocialMediaIcons;
